import { GroupModel } from './convert-grouping'

export type AgGridSortModel<T> = {
  colId: keyof T
  sort: 'asc' | 'desc'
  abs?: boolean
}

export interface SortModel<T> {
  field: keyof T
  direction: 'asc' | 'desc'
  abs?: boolean
}

/** Convert ag-grid sortModel to Helios backend sortModel */
export function convertSortModel<T>(
  sortModel: AgGridSortModel<T>[],
  group: GroupModel<T>,
  sortByAbsolute?: boolean,
): SortModel<T>[] {
  /**
   * group.fields.length correlates to the number of grouped columns
   * group.keys.length correlates to the number of expanded groups
   *
   * The backend only allows you to sort multiple columns if all groups are expanded.
   * In addition, when there are unexpanded groups the only group that can be sorted is the last collapsed group.
   */
  if (group.keys.length < group.fields.length) {
    return sortModel
      .filter(model => group.fields[group.keys.length]?.field === model.colId)
      .map(model => normalizeAgGridSortModel(model, sortByAbsolute))
  } else {
    return sortModel.map(model =>
      normalizeAgGridSortModel(model, sortByAbsolute),
    )
  }
}

/**
 * Normalize the sort model to bring explicitly set properties that are null
 */
function normalizeAgGridSortModel<T>(
  model: AgGridSortModel<T>,
  sortByAbsolute?: boolean,
): SortModel<T> {
  return {
    field: model.colId,
    direction: model.sort,
    // Default defined here: https://stash.arbfund.com/projects/HEL/repos/helios/browse/libs/request-model/src/main/kotlin/com/clearwateranalytics/helios/requests/sort/SortField.kt#9
    abs: sortByAbsolute ?? model.abs ?? false,
  }
}
